// The published nightly rate is the price the customer pays. We present it as a
// discounted deal by showing a struck-through "original" that is 10% higher than
// the pay-price, plus an "X% OFF" badge, to make the saving visible and
// encourage booking:
//
//   originalPrice = payPrice * (1 + RATE)
//
// The pay-price itself is never changed. All math is done on the raw rate (in the
// base currency) BEFORE any currency conversion — the ratio is currency-
// invariant, so callers can pass the result straight to displayPrice().

export const STANDING_DISCOUNT_RATE = 0.1

export const STANDING_DISCOUNT_PERCENT = Math.round(STANDING_DISCOUNT_RATE * 100)

export interface DiscountInfo {
  /** Whether there's a meaningful discount worth showing. */
  hasDiscount: boolean
  /** The inflated "original" price, shown struck-through (payPrice + 10%). */
  originalPrice: number
  /** The price actually charged (unchanged). */
  discountedPrice: number
  /** Whole-number percent advertised as saved, e.g. 10. */
  percent: number
}

export const getStandingDiscount = (
  payRate: number | null | undefined,
): DiscountInfo => {
  const rate = Number(payRate) || 0

  if (rate <= 0) {
    return { hasDiscount: false, originalPrice: 0, discountedPrice: 0, percent: 0 }
  }

  const originalPrice = Math.round(rate * (1 + STANDING_DISCOUNT_RATE))

  return {
    hasDiscount: originalPrice > rate,
    originalPrice,
    discountedPrice: rate,
    percent: STANDING_DISCOUNT_PERCENT,
  }
}
